import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Setting } from '../App';
import { useAddress } from '../hooks/use-address';

export const Address: FC<{ setting: Setting }> = ({ setting }) => {
  const { subscription, formRef, redirectToShowPage, setSubscription, changeCountry, submit } = useAddress(setting);

  if (!subscription) {
    return <></>;
  }

  if (!subscription.shop.showChangeAddress) {
    redirectToShowPage();

    return <></>;
  }

  const countryOptions = subscription.countries.map((country, i) => (
    <option key={i} value={country.code} selected={country.code === subscription.deliveryCountryCode}>
      {country.name}
    </option>
  ));

  const provinceOptions = subscription.country.zones.map((zone, i) => (
    <option key={i} value={zone.code} selected={zone.code === subscription.deliveryProvinceCode}>
      {zone.name}
    </option>
  ));

  return (
    <div className="grid__item">
      <form ref={formRef}>
        <div className="form-vertical">
          <h2>配送住所を編集する</h2>

          <div className="grid">
            <div className="grid__item medium-up--one-half">
              <label>姓</label>
              <input
                type="text"
                required
                onChange={(event) =>
                  setSubscription({
                    ...subscription,
                    deliveryLastName: event.target.value,
                  })
                }
                value={subscription.deliveryLastName}
              />
            </div>

            <div className="grid__item medium-up--one-half">
              <label>名</label>
              <input
                type="text"
                required
                onChange={(event) =>
                  setSubscription({
                    ...subscription,
                    deliveryFirstName: event.target.value,
                  })
                }
                value={subscription.deliveryFirstName}
              />
            </div>
          </div>

          <div className="grid">
            <div className="grid__item medium-up--one-half">
              <label>国/地域</label>
              <select
                onChange={(event) => {
                  changeCountry(event.target.value);
                }}
              >
                {countryOptions}
              </select>
            </div>

            <div className="grid__item medium-up--one-half">
              <label>郵便番号</label>
              <input
                type="text"
                required
                onChange={(event) =>
                  setSubscription({
                    ...subscription,
                    deliveryZip: event.target.value,
                  })
                }
                value={subscription.deliveryZip}
              />
            </div>
          </div>

          <div className="grid">
            <div className="grid__item medium-up--one-half">
              <label>都道府県</label>
              <select
                onChange={(event) =>
                  setSubscription({
                    ...subscription,
                    deliveryProvinceCode: event.target.value,
                  })
                }
              >
                {provinceOptions}
              </select>
            </div>

            <div className="grid__item medium-up--one-half">
              <label>市区町村</label>
              <input
                type="text"
                required
                onChange={(event) =>
                  setSubscription({
                    ...subscription,
                    deliveryCity: event.target.value,
                  })
                }
                value={subscription.deliveryCity}
              />
            </div>
          </div>

          <div className="grid">
            <div className="grid__item">
              <label>住所</label>
              <input
                type="text"
                required
                onChange={(event) =>
                  setSubscription({
                    ...subscription,
                    deliveryAddress1: event.target.value,
                  })
                }
                value={subscription.deliveryAddress1}
              />
            </div>
          </div>

          <div className="grid">
            <div className="grid__item">
              <label>建物名、部屋番号 (任意)</label>
              <input
                type="text"
                onChange={(event) =>
                  setSubscription({
                    ...subscription,
                    deliveryAddress2: event.target.value,
                  })
                }
                value={subscription.deliveryAddress2}
              />
            </div>
          </div>

          <div className="text-center">
            <div>
              <button onClick={submit} type="submit" className="btn" disabled={subscription.disabled}>
                更新
              </button>
            </div>
            <div>
              <Link
                to={`/subscriptions/${encodeURIComponent(subscription.subscriptionContractId)}`}
                className="text-link address-edit-toggle"
              >
                キャンセル
              </Link>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
